import { gql } from 'graphql-request';

import { graphQLApi } from 'utils/Api';

import {
  PayrollGetPayDetailsBulkPreviewResponse,
  PayrollGetPayDetailsBulkPreviewArgs,
  PayDetailsBulkPreviewGraphQLRequest,
} from './types';

const getPayDetailsBulkPreviewQuery = gql`
  query PayrollGetPayDetailsBulkPreview($input: PayDetailsBulkPreviewInput!) {
    payrollGetPayDetailsBulkPreview(input: $input) {
      code
      success
      message
      data {
        requestId
        revisionDetails {
          userId
          annualSalary
          effectiveFrom
          salaryStructureId
          earnings {
            displayName
            componentName
            payType
            annualAmount
            monthlyAmount
          }
          compliances {
            displayName
            annualAmount
          }
          earningArrears {
            displayName
            amount
          }
          complianceArrears {
            displayName
            amount
          }
          arrearSources
        }
      }
    }
  }
`;

export const getPayDetailsBulkPreview = async (
  input: PayrollGetPayDetailsBulkPreviewArgs,
): Promise<PayrollGetPayDetailsBulkPreviewResponse> => {
  return graphQLApi<PayrollGetPayDetailsBulkPreviewResponse, PayDetailsBulkPreviewGraphQLRequest>({
    query: getPayDetailsBulkPreviewQuery,
    queryVariables: { input },
  });
};

export default { getPayDetailsBulkPreview };
